import { render, staticRenderFns } from "./ChildTickets.vue?vue&type=template&id=7a6910c4&"
import script from "./ChildTickets.vue?vue&type=script&lang=js&"
export * from "./ChildTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports